import { addHours } from 'date-fns'

import { OlympusClient } from '@/OlympusClient'
import store from '@/store'

import { type CampaignResource, type CampaignResourceUpdate } from '../types'

import { fetchResource } from './fetchTextData'

export const updateResourceHandler = async (
  campaignId: string,
  { name, sections, executeAt }: CampaignResourceUpdate
): Promise<CampaignResource> => {
  const { smsTemplateId } = store.getters[
    'textBuilder/currentResource'
  ] as unknown as CampaignResource

  await Promise.all([
    OlympusClient.notifications.v1.templates.sms.sms.updateSMSTemplate({
      body: {
        name,
        sections,
      },
      params: { smsTemplateId },
    }),
    OlympusClient.marketing.v1.campaigns.campaign.updateCampaign({
      body: {
        executeAt: executeAt ? new Date(executeAt).toISOString() : null,
        expiresAt: executeAt
          ? addHours(new Date(executeAt), 2).toISOString()
          : null,
        name,
      },
      params: { campaignId },
    }),
  ])

  const { resource } = await fetchResource(campaignId)

  return resource
}
